import { Shield, ShieldCheck, ShieldAlert } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';

const CFG = {
  unverified: { c: 'bg-gray-100 text-gray-500', Icon: Shield },
  part_verified: { c: 'bg-amber-100 text-amber-700', Icon: ShieldAlert },
  active_verified: { c: 'bg-[#00A79D]/10 text-[#00857D]', Icon: ShieldCheck },
  tested_proven: { c: 'bg-[#00A79D] text-white', Icon: ShieldCheck },
};

export const TrustBadge = ({ trust, showUnverified = false, compact = false, testid }) => {
  if (!trust) return null;
  const cfg = CFG[trust.tier] || CFG.unverified;
  if (trust.tier === 'unverified' && !showUnverified) return null;
  const { Icon } = cfg;
  const badge = (
    <span
      className={`inline-flex items-center gap-1 font-semibold rounded-full cursor-help ${compact ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1'} ${cfg.c}`}
      data-testid={testid || `trust-badge-${trust.tier}`}>
      <Icon className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} /> {trust.label}
    </span>
  );
  if (!trust.blurb) return badge;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent style={{ color: '#ffffff', backgroundColor: '#1A3A5F' }} className="max-w-xs leading-relaxed py-2 px-3 border-0" data-testid={`${testid || `trust-badge-${trust.tier}`}-tooltip`}>
          {trust.blurb}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
